"use client"

import { ProfileCommunity } from "@/app/entities/BFF/ProfileShort"
import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

const fetchClientBlockUserProfiles = (profileIds: string[]) =>
  fetchInterceptorInClient(
    {
      method: "post",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/community/profiles`, { profileIds })
    .then((res) => {
      console.log(res)
      return res
    })
    .then(resultPostprocessing2<ProfileCommunity[]>)

export default fetchClientBlockUserProfiles
